/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */

export const awanColorBrandPrimary = '#00b14f';
export const awanColorBrandSecondary = '#005339';
export const awanColorBrandTertiary = '#d9fcde';
export const awanColorBackgroundPrimary = '#1a1a1a';
export const awanColorBackgroundSecondary = '#292929';
export const awanColorBackgroundTertiary = '#3d3d3d';
export const awanColorBackgroundBorder = '#707070';
export const awanColorBackgroundInverse = '#ffffff';
export const awanColorBackgroundPositive = '#3cb95a';
export const awanColorBackgroundInformativeDefault = '#0b54a8';
export const awanColorBackgroundInformativeAlt = '#0c2b45';
export const awanColorBackgroundNoticeDefault = '#ffbc05';
export const awanColorBackgroundNoticeAlt = '#824703';
export const awanColorBackgroundNegativeDefault = '#f55538';
export const awanColorBackgroundNegativeAlt = '#530e08';
export const awanColorSheetPrimary = '#292929';
export const awanColorSheetSecondary = '#3d3d3d';
export const awanColorSheetTertiary = '#575757';
export const awanColorSheetOverlay = 'rgba(0, 0, 0, 0.6)';
export const awanColorTextPrimary = '#ffffff';
export const awanColorTextSecondary = '#bfbfbf';
export const awanColorTextInverse = '#1a1a1a';
export const awanColorTextInactive = '#707070';
export const awanColorTextDisabled = '#8c8c8c';
export const awanColorTextLink = '#3ab5ee';
export const awanColorTextPositive = '#3cb95a';
export const awanColorTextNegative = '#f55538';
export const awanColorTextNotice = '#ffbc05';
export const awanColorSymbolsPrimary = '#ffffff';
export const awanColorSymbolsSecondary = '#a3a3a3';
export const awanColorSymbolsInverse = '#1a1a1a';
export const awanColorSymbolsInactive = '#707070';
export const awanColorSymbolsDisabled = '#8c8c8c';
export const awanColorSymbolsSeparatorThin = '#3d3d3d';
export const awanColorSymbolsSeparatorThick = '#292929';
export const awanColorSymbolsLink = '#3ab5ee';
export const awanColorSymbolsPositive = '#3cb95a';
export const awanColorSymbolsNegative = '#f55538';
export const awanColorSymbolsNotice = '#ffbc05';
export const awanColorSymbolsSafety = '#01b5bc';
export const awanColorStatesPressedPrimary = '#00804a';
export const awanColorStatesPressedSecondary = '#3d3d3d';
export const awanColorStatesPressedLink = '#136fd8';
export const awanColorStatesPressedAlert = '#d42e1c';
export const awanColorStatesSelectedEnabled = '#3cb95a';
export const awanColorStatesDeselectedEnabled = '#bfbfbf';
export const awanColorStatesDisabledPrimary = '#3d3d3d';
export const awanColorStatesDisabledSecondary = '#575757';
